import { AnimatePresence, motion } from "framer-motion";
import { useAppDispatch } from "hooks/hooks";
import { useEffect, useState } from "react";
import { FaPlay, FaTimes } from "react-icons/fa";
import { getHomeDemoVideos } from "redux/features/Admin/homeVideo/homeVideoSlice";
import img from "../../src/images/bg.png";

const VideoModal = ({ isOpen, onClose, videoUrl }: { isOpen: boolean; onClose: () => void; videoUrl: string }) => {
  if (!isOpen) return null;

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70 backdrop-blur-sm"
          onClick={onClose}
        >
          <motion.div
            initial={{ scale: 0.7, opacity: 0, y: 50 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.7, opacity: 0, y: 50 }}
            transition={{ duration: 0.4, ease: "easeOut" }}
            className="relative w-full max-w-4xl p-1 mx-4 bg-white shadow-2xl cursor-pointer rounded-2xl"
            onClick={onClose}
          >
            <motion.button
              whileHover={{ scale: 1.1, rotate: 90 }}
              whileTap={{ scale: 0.9 }}
              className="absolute z-50 flex items-center justify-center w-10 h-10 text-white transition-colors bg-red-800 rounded-full top-4 right-4 hover:bg-gray-900"
              onClick={onClose}
            >
              <FaTimes className="text-lg" />
            </motion.button>
            <div className="relative w-full h-0 pb-[56.25%] overflow-hidden rounded-xl shadow-inner">
              <video
                className="absolute top-0 left-0 w-full h-full"
                src={process.env.REACT_APP_CLOUD_FRONT + videoUrl}
                autoPlay
                loop
                muted
                controls
              ></video>
            </div>
            {!videoUrl && (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                className="absolute inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 rounded-xl"
              >
                <div className="text-lg font-semibold text-white">Loading video...</div>
              </motion.div>
            )}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

const DemoHomePage = () => {
  const dispatch = useAppDispatch();
  const [videoUrl, setVideoUrl] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const fetch = async () => {
    const res = await dispatch(getHomeDemoVideos());
    setVideoUrl(res.payload.url);
  };

  useEffect(() => {
    fetch();
  }, []);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div>
      <div className="flex items-center justify-center">
        <div className="flex flex-col w-full overflow-hidden bg-white md:flex-row rounded-3xl dark:bg-neutral-800">
          <div className="flex flex-col justify-center p-8 md:w-1/2">
            <h1 className="text-3xl font-bold leading-tight text-gray-800 md:text-4xl dark:text-white">
              Louer un espace événementiel et plus encore...
            </h1>
            <p className="mt-4 text-base text-gray-600 md:text-lg">
              Organisez votre événement en toute simplicité grâce à EventToBee. Découvrez notre sélection d’espaces
              événementiels : lieux atypiques, salles de réunion, jardins, villas, péniches... Trouvez l’endroit
              idéal pour votre projet, privé ou professionnel .
            </p>

            <div className="flex justify-start mt-5">
              <button
                className="relative flex items-center justify-start px-4 py-2 font-medium text-gray-500 w-60"
                onClick={handleOpenModal}
              >
                <div className="flex items-center justify-center w-10 h-10 mr-3 text-white rounded-full bg-eventToBee ">
                  <FaPlay className="text-sm text-white" />
                </div>
                <span className="text-gray-500">Voir la démo</span>
              </button>
            </div>
          </div>

          <div className="relative md:w-1/2">
            <img src={img} alt="Couple with sold sign" className="object-cover w-full h-full" />
            {/* <img src={mokaup} className="absolute top-0 left-0 w-full h-full" alt="mokup-5" /> */}
          </div>
        </div>
      </div>

      <VideoModal isOpen={isModalOpen} onClose={handleCloseModal} videoUrl={videoUrl} />
    </div>
  );
};

export default DemoHomePage;
